import axios from 'axios';
import { stringify } from 'query-string';
import * as CONSTANTS from '../../constants/index';
import { getValidationErrors } from '../../utils';
import { getConfig } from "../../reducers/portalConfig";
import { AXIOS_DEFAULT_OPTIONS } from '../';
import { isEmpty } from 'lodash';
import { CHANGE_MODE_ADD_ACCESS, CHANGE_MODE_REMOVE_ACCESS } from '../../pages/ApiGroups/Details';

export const fetchApiGroupsList = () => async (dispatch, getState) => {
  const config = getConfig(getState());
  const { portal } = config;

  const url = `${portal.hostname}/api/${portal.tenantPrefix}/api-management/1.0/api-groups`;

  dispatch({ type: CONSTANTS.API_GROUPS_REQUEST });
  await axios.get(url, AXIOS_DEFAULT_OPTIONS)
    .then(response => dispatch({ type: CONSTANTS.API_GROUPS_SUCCESS, payload: response.data }))
    .catch((error) => dispatch({
      type: CONSTANTS.API_GROUPS_ERROR, payload: getValidationErrors(error),
    }));
};

export const fetchApisForApiGroups = (
  apiGroupUuid,
  {
    size,
    page,
    name,
    apiGroupApiAccessStatus,
  } = {},
) => async (dispatch, getState) => {
  const config = getConfig(getState());
  const { portal } = config;
  const params = stringify({
    size,
    page,
    apiGroupApiAccessStatus,
    name: !isEmpty(name) ? name : undefined,
  })
  const url = `${portal.hostname}/api/${portal.tenantPrefix}/api-management/1.0/access/apis-api-group/${apiGroupUuid}?${params}`;

  await axios.get(url, AXIOS_DEFAULT_OPTIONS)
    .then(response => dispatch({
      type: CONSTANTS.GET_AVAILABLE_APIS_FOR_API_GROUPS_SUCCESS,
      payload: response.data,
    }))
    .catch((error) => dispatch({
      type: CONSTANTS.GET_AVAILABLE_APIS_FOR_API_GROUPS_ERROR, payload: getValidationErrors(error),
    }));
};

export const createApiGroup = (payload) => (
  async (dispatch, getState) => {
    const config = getConfig(getState());
    const { portal } = config;
    const url = `${portal.hostname}/api/${portal.tenantPrefix}/api-management/1.0/api-groups`;
    dispatch({ type: CONSTANTS.CREATE_API_GROUP_REQUEST });
    await axios.post(url, payload, AXIOS_DEFAULT_OPTIONS)
      .then((response) => {
        dispatch({ type: CONSTANTS.CREATE_API_GROUP_SUCCESS, payload: response.data })
      })
      .catch((error) => {
        dispatch({ type: CONSTANTS.CREATE_API_GROUP_ERROR, payload: getValidationErrors(error) })
      })
  }
)

export const fetchApiGroup = (apiGroupUuid) => (
  async (dispatch, getState) => {
    const config = getConfig(getState());
    const { portal } = config;
    const url = `${portal.hostname}/api/${portal.tenantPrefix}/api-management/1.0/api-groups/${apiGroupUuid}`;
    dispatch({ type: CONSTANTS.FETCH_SINGLE_API_GROUP_REQUEST });
    await axios.get(url, AXIOS_DEFAULT_OPTIONS)
      .then((response) => {
        dispatch({ type: CONSTANTS.FETCH_SINGLE_API_GROUP_SUCCESS, payload: response.data })
      })
      .catch((error) => {
        dispatch({
          type: CONSTANTS.FETCH_SINGLE_API_GROUP_ERROR,
          payload: getValidationErrors(error),
        })
      })
  }
)

export const editApiGroup = (payload, apiGroupUuid) => (
  async (dispatch, getState) => {
    const config = getConfig(getState());
    const { portal } = config;
    const url = `${portal.hostname}/api/${portal.tenantPrefix}/api-management/1.0/api-groups/${apiGroupUuid}`;
    dispatch({ type: CONSTANTS.EDIT_API_GROUP_REQUEST });
    await axios.put(url, payload, AXIOS_DEFAULT_OPTIONS)
      .then(() => {
        dispatch({ type: CONSTANTS.EDIT_API_GROUP_SUCCESS, payload: CONSTANTS.SUCCESS })
      })
      .catch((error) => {
        dispatch({ type: CONSTANTS.EDIT_API_GROUP_ERROR, payload: getValidationErrors(error) })
      })
  }
)

export const deleteApiGroup = (apiGroupUuid) => (
  async (dispatch, getState) => {
    const config = getConfig(getState());
    const { portal } = config;
    const url = `${portal.hostname}/api/${portal.tenantPrefix}/api-management/1.0/api-groups/${apiGroupUuid}`;
    dispatch({ type: CONSTANTS.DELETE_API_GROUP_REQUEST });
    await axios.delete(url, AXIOS_DEFAULT_OPTIONS)
      .then(() => {
        dispatch({ type: CONSTANTS.DELETE_API_GROUP_SUCCESS, payload: CONSTANTS.SUCCESS })
      })
      .catch((error) => {
        dispatch({ type: CONSTANTS.DELETE_API_GROUP_ERROR, payload: getValidationErrors(error) })
      })
  }
)

export const fetchApiGroupNameUnique = (apiGroupName) => (
  async (dispatch, getState) => {
    const config = getConfig(getState());
    const { portal } = config;
    const url = `${portal.hostname}/admin/api-management/internal/api-group-name-available?name='${apiGroupName}'`;
    await axios.get(url, AXIOS_DEFAULT_OPTIONS)
      .then((response) => {
        dispatch({ type: CONSTANTS.FETCH_API_GROUP_NAME_UNIQUE_SUCCESS, payload: response.data })
      })
      .catch((error) => {
        dispatch({
          type: CONSTANTS.FETCH_API_GROUP_NAME_UNIQUE_ERROR,
          payload: getValidationErrors(error),
        })
      })
  }
)

export const updateApisForApiGroups = (payload, apiGroupUuid, changeMode) => {
  return async (dispatch, getState) => {
    try {
      const config = getConfig(getState());
      const { portal } = config;
      const action = changeMode === CHANGE_MODE_ADD_ACCESS ? "add" :
        changeMode === CHANGE_MODE_REMOVE_ACCESS ? "remove" : "";

      const params = stringify({ action });

      const url = `${portal.hostname}/api/${portal.tenantPrefix}/api-management/1.0/api-groups/${apiGroupUuid}/apis?${params}`;

      await axios.patch(url, payload, AXIOS_DEFAULT_OPTIONS);

      dispatch({
        type: CONSTANTS.UPDATE_APIS_FOR_API_GROUPS_SUCCESS,
        payload: CONSTANTS.SUCCESS,
      });
    } catch (error) {
      dispatch({
        type: CONSTANTS.UPDATE_APIS_FOR_API_GROUPS_ERROR,
        payload: getValidationErrors(error),
      });
    }
  };
};
